<po-page-default>
  <h1 class="po-font-title">Olá, {{ nameUsr }}</h1>
  <br />
  <br />
  <!-- @if (ciclesdisabled) {
    <p class="po-font-subtitle">Desejamos boas vindas ao Painel da Gestão!</p>
  }
  @if (!ciclesdisabled && showButton) {
    <div>
      @for (step of steppers; track step) {
        <div class="stepper-step-container">
          <br>
            <br>
              <h3>Ciclo - {{step.name}}</h3>
              <br>
                <div class="stepper-wrapper" >
                  <div class="stepper-item {{step.step1}}">
                    <div class="step-counter">
                      @if (step.step1 == 'completed') {
                        <span class=" an an-check"></span>
                      }
                    </div>
                    <div class="stepper-step-bar-right"></div>
                    <div class="step-name {{step.step1}}">Cadastros de Metas</div>
                    <span class="step-date {{step.step1}}">{{step.goalResult}}</span>
                  </div>
                  <div class="stepper-item {{step.step2}}">
                    <div class="step-counter">
                      @if (step.step2 == 'completed') {
                        <span class=" an an-check"></span>
                      }
                    </div>
                    <div class="stepper-step-bar-left"></div>
                    <div class="stepper-step-bar-right"></div>
                    <div class="step-name {{step.step2}} ">Atualização de Metas</div>
                    <span class="step-date {{step.step2}}">de 01 a 05 de cada mês</span>
                  </div>
                  <div class="stepper-item {{step.step3}}">
                    <div class="step-counter">
                      @if (step.step3 == 'completed') {
                        <span class=" an an-check"></span>
                      }
                    </div>
                    <div class="step-name {{step.step3}}">Resultados Apuração Coletiva/Individual</div>
                    <span class="step-date {{step.step3}}">{{step.result}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        } -->
  <app-schedule></app-schedule>
</po-page-default>
